/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Biz_CtaInputs */

const en_mk_price_biz_cta = /** @type {(inputs: Mk_Price_Biz_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start on Business`)
};

const id_mk_price_biz_cta = /** @type {(inputs: Mk_Price_Biz_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai tier Bisnis`)
};

/**
* | output |
* | --- |
* | "Start on Business" |
*
* @param {Mk_Price_Biz_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_biz_cta = /** @type {((inputs?: Mk_Price_Biz_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Biz_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_biz_cta(inputs)
	return en_mk_price_biz_cta(inputs)
});